import * as React from 'react';
import { casesService, GET_QUESTIONS } from '@/api';
import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';
import { Survey } from '../landing/file-claim/survey';
import { LoaderScreen } from '@/components/common';
import { deleteLocalStorage } from '@/utils/localStorage';
import { StatusCaseItem } from '@/interfaces';
import clsx from 'clsx';

export const FileYourClaimScreen = ({
	previewQuestions,
	previewMode,
	id,
	status,
}: {
	previewQuestions?: any[];
	previewMode?: boolean;
	id: string;
	status: StatusCaseItem;
}) => {
	const router = useRouter();
	const { slug } = router.query;

	const { data: questionsRes, isLoading } = useQuery({
		queryKey: [GET_QUESTIONS, slug],
		queryFn: () => casesService.getQuestions(slug as string),
		enabled: !!slug,
		refetchOnWindowFocus: false,
	});

	const questions = previewQuestions
		? previewQuestions
		: questionsRes?.data || [];

	React.useEffect(() => {
		deleteLocalStorage('case_id');
	}, []);

	return (
		<div className="relative z-10">
			{isLoading ? (
				<LoaderScreen className="my-10" />
			) : (
				<div
					className={clsx(
						'relative h-full w-full xl:w-[561px] xl:mt-11 lg:mt-0',
						{
							'!mx-auto !mt-16': previewMode,
						}
					)}
				>
					<div
						aria-hidden="true"
						className="hidden xl:block absolute bottom-0 right-0 w-[400px] h-[450px] pointer-events-none select-none z-0"
					>
						<div className="absolute bottom-12 -right-16 w-[260px] h-[260px] rounded-full bg-[#8F20EF] opacity-20 blur-[90px]" />
						<div className="absolute bottom-28 -right-4 w-[240px] h-[240px] rounded-full bg-[#2084E7] opacity-20 blur-[90px]" />
					</div>
					<div className="relative z-10">
						<Survey
							uuid={id}
							id={slug as string}
							questions={Array.isArray(questions) ? questions : []}
							previewMode={previewMode}
							status={status}
						/>
					</div>
				</div>
			)}
		</div>
	);
};
